import { DatePicker, Input, Modal } from 'antd';
import moment from 'moment';
import * as React from 'react';

const { TextArea } = Input;

interface ILocalProps {
    companyID: number,
    companyName: string,
    note: string,
    onCancel: () => void,
    onNoteChange: (e: any) => void,
    onRequestDateChange: (date: moment.Moment, dateString: string) => void,
    onSave: () => void,
    onTerminationDateChange: (date: moment.Moment, dateString: string) => void,
    requestDate: moment.Moment,
    terminationDate: moment.Moment,
}

const SetTerminationModal: React.SFC<ILocalProps> = (props: ILocalProps): JSX.Element => {
    return (
        <Modal
            title={`Create Termination Request for ${props.companyName} (${props.companyID})`}
            visible={true}
            onCancel={props.onCancel}
            onOk={props.onSave}
            okText="Save"
        >
            <h4>Request Date</h4>
            <DatePicker placeholder="Request Date" onChange={props.onRequestDateChange} value={props.requestDate} />
            <h4>Termination Date</h4>
            <DatePicker placeholder="Termination Date" onChange={props.onTerminationDateChange} value={props.terminationDate}/>
            <h4>Note</h4>
            <TextArea rows={4} placeholder="Note" onChange={props.onNoteChange} value={props.note} />
        </Modal>
    );
}

export default SetTerminationModal;
